import { useHumanHandoverStore } from '@/stores/humanHandover/humanHandoverStore';

/**
 * Hook to determine if file upload is allowed based on context and settings
 *
 * @param {boolean} isInHumanHandoverApp - Whether we're in the agent dashboard
 * @param {boolean} pollResponse - Whether an agent has joined (user side)
 * @returns {boolean} Whether file upload should be allowed
 */
const useFileUploadPermission = (isInHumanHandoverApp, pollResponse) => {
  const { fileUploadSetting } = useHumanHandoverStore();

  // Helper function to extract boolean value from setting
  const getSettingValue = (setting) => {
    if (setting === null || setting === undefined) {
      return false;
    }
    return typeof setting === 'boolean' ? setting : setting?.allow_file_upload;
  };

  // For agent side (human handover app)
  if (isInHumanHandoverApp) {
    return getSettingValue(fileUploadSetting);
  }

  // For user side (shared chat bubble)
  // IMPORTANT: Only show button after we have received the actual API response
  // fileUploadSetting starts as null, then becomes the actual response (true/false or object)
  if (pollResponse) {
    // If agent has joined but we haven't received the setting yet, hide button
    if (fileUploadSetting === null) {
      return false;
    }

    // If we have received the setting response, check if it allows uploads
    return getSettingValue(fileUploadSetting);
  }

  // Hide button until agent joins
  return false;
};

export default useFileUploadPermission;
